import { useState } from 'react'
import PropTypes from 'prop-types'
import { PencilSimple } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import CheckboxField from '../FormLegacy/FormFieldsV2/CheckboxField'

import EscalationAttemptField from './EscalationsAttemptFiled'

const EmergencyNotifications = ({ index, updateLevel, call, sms, email, push }) => {
  const { t } = useTranslation(['on-call-schedule'])
  const [editMode, setEditMode] = useState(false)

  return (
    <div className="escalations-order__item--notifications-wrap">
      <p className="escalations-order__item--notifications-text">
        {t('on-call-schedule:emergencyNotifications.notifyBy')}
      </p>
      <div className="escalations-order__item--notifications">
        <div className="escalations-order__item--notifications-call">
          {editMode ? (
            <EscalationAttemptField
              defaultAttempt={call.attempt}
              onSave={(attempt) => {
                updateLevel(index, {
                  call: {
                    ...call,
                    isEnabled: true,
                    attempt,
                  },
                })
                setEditMode(false)
              }}
            />
          ) : (
            <div className="escalations-order__item--notifications-checkbox">
              <CheckboxField
                name={`call=${index}`}
                onChange={() =>
                  updateLevel(index, {
                    call: { ...call, isEnabled: !call.isEnabled },
                  })
                }
                checked={call.isEnabled}
                label={t('on-call-schedule:emergencyNotifications.callAttempts', {
                  count: call.attempt,
                })}
              />
              <div className="edit-btn" onClick={() => setEditMode(true)}>
                <PencilSimple size={16} />
              </div>
            </div>
          )}
        </div>
        <div>
          <CheckboxField
            name={`sms-${index}`}
            onChange={() => updateLevel(index, { sms: !sms })}
            checked={sms}
            label={t('on-call-schedule:emergencyNotifications.sms')}
          />
        </div>
        <div>
          <CheckboxField
            name={`email-${index}`}
            onChange={() => updateLevel(index, { email: !email })}
            checked={email}
            label={t('on-call-schedule:emergencyNotifications.email')}
          />
        </div>
        <div>
          <CheckboxField
            name={`push-${index}`}
            onChange={() => updateLevel(index, { push: !push })}
            checked={push}
            label={t('on-call-schedule:emergencyNotifications.push')}
          />
        </div>
      </div>
    </div>
  )
}

EmergencyNotifications.propTypes = {
  updateLevel: PropTypes.func,
  index: PropTypes.number,
  call: PropTypes.object,
  sms: PropTypes.bool,
  email: PropTypes.bool,
  push: PropTypes.bool,
}

export default EmergencyNotifications
